"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OuterCircle = exports.MiddleCircle = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var OuterCircle = exports.OuterCircle = _styledComponents["default"].div(function (props) {
  return "\n  height: ".concat(props.height, ";\n  width: ").concat(props.width, ";\n  border-radius: 50%;\n  background-color: rgba(255, 255, 255, 0.2);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n");
});
var MiddleCircle = exports.MiddleCircle = _styledComponents["default"].div(function (props) {
  return "\n  height: ".concat(props.height, ";\n  width: ").concat(props.width, ";\n  border-radius: 50%;\n  background: linear-gradient(209deg,\n    ").concat(props.theme.secondary.block.accent, " 27.59%,\n    ").concat(props.theme.secondary.block.container, " 48.97%,\n    ").concat(props.theme.secondary.block.accent, " 70.63%);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  opacity: 99.99%\n  ");
});